export default "__VITE_ASSET__Oq_qWG$D__"